import imageURIs from "../resources/ImageURIs";
import {MAC_LENGTH} from "../constants/Constants";

export default class Helper {
    static getAmbientLightImage(luxData) {
        if (luxData === 0) {
            return imageURIs.ambient_off;
        } else if (luxData > 0 && luxData <= 2) {
            return imageURIs.ambient_dark;
        } else if (luxData > 2 && luxData <= 6) {
            return imageURIs.ambient_dim;
        } else if (luxData > 6 && luxData <= 11) {
            return imageURIs.ambient_moderate;
        } else {
            return imageURIs.ambient_bright;
        }
    }

    static toFahrenheit(celsius) {
        return celsius * 1.8 + 32.0;
    }

    static validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static validateMac = (mac) => {
       return (mac.length == MAC_LENGTH)
    }

}